import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'FormStepSubmitting',
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const errorMessage = ref('')

        const loading = computed( () => {
            return props.isSubmitting
        })



        onMounted(async () => {
            await submit()
        })

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'formStepSubmitting',
                labelKey: labelKey
            })

        const submit = async () => {
            if (props.submitCallback) {
                await props.submitCallback()
            }
        }


        const submitRetry = async () => {
            loading.value = true
            errorMessage.value = ''
            await submit()
        }

        return {
            loading,
            errorMessage,
            submitRetry,
            getLabel
        }
    }
}
